import { notification } from 'antd';
import actions from './actions';
import { DataService } from '../../../config/dataService/dataService';

const GENERIC_API_ERROR = process.env.REACT_APP_GENERIC_ERROR_MESSAGE;

const {
  esquemasContractualesList,
  esquemasContractualesListSelectBox,
  esquemasContractualesCreate,
  esquemasContractualesRead,
  esquemasContractualesUpdate,
  esquemasContractualesDelete,  
} = actions;

const esquemasContractualesListAction = (paramBusqueda = '') => {
  return async dispatch => {
    try {
      const response = await DataService.get('/esquemasContractuales/list.php?paramBusqueda=' + paramBusqueda);      
      
      if (response.status === 200 && response.data.data) {       
        dispatch(esquemasContractualesList(response.data.data));
        return true
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};


const esquemasContractualesCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/esquemasContractuales/manage.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const esquemasContractualesReadAction = (id = '') => {
  return async dispatch => {
    try {
      if (id != '') {
        const response = await DataService.get('/esquemasContractuales/manage.php?id=' + id);
        if (response.status === 200 && response.data.data) {
          dispatch(esquemasContractualesRead(response.data.data));
          return true;
        }
      } else {
        dispatch(esquemasContractualesRead({}));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

/////////////////

export {
  esquemasContractualesListAction,
  esquemasContractualesCreateAction,
  esquemasContractualesReadAction,    
};
